
import { rei } from "@/services/api"

export default class CertidaoService {
  static gerarJsonFromResumo (payload, tipoRegistro) {
    return rei.post(`${tipoRegistro}/resumo/json`, payload).then(res => res)
  }
  static gerarCertidaoEletronica (payload, tipoRegistro) {
    return rei.post(`${tipoRegistro === 'habilitacao' ? tipoRegistro + '-casamento' : tipoRegistro}/resumo/certidao-eletronica`, payload).then(res => res)
  }
  static assinarCertidaoEletronica (tipoRegistro, certidaoId, registroId ) {
    return rei.post(`${tipoRegistro === 'habilitacao' ? tipoRegistro + '-casamento' : tipoRegistro}/resumo/assinar-certidao-eletronica`, {certidao_id: certidaoId, registro_id: registroId}).then(res => res)
  }
  static gerarJsonInteiroTeor (payload, tipoRegistro) {
    return rei.post(`${tipoRegistro}/resumo/json-certidao-eletronica`, payload).then(res => res)
  }

}